import { FC, ReactNode } from 'react'

import { Card, CardContent, CardHeader, CardTitle, Skeleton } from '@forto-dev/phoenix-ui-core'

type DashboardWidgetCardProps = {
  title?: string
  children: ReactNode
}

export const DashboardWidgetCard: FC<DashboardWidgetCardProps> = ({ title, children }) => (
  <Card>
    {title ? (
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
    ) : null}
    <CardContent>{children}</CardContent>
  </Card>
)

type DashboardWidgetCardSkeletonProps = {
  // Must match whether the loaded widget has a title, or the card shifts when data arrives.
  withTitle?: boolean
  children?: ReactNode
}

export const DashboardWidgetCardSkeleton: FC<DashboardWidgetCardSkeletonProps> = ({ withTitle = false, children }) => (
  <Card>
    {withTitle ? (
      <CardHeader>
        <Skeleton variant="content" />
      </CardHeader>
    ) : null}
    <CardContent>{children ?? <Skeleton variant="card" fullWidth />}</CardContent>
  </Card>
)
